export const gamificationScoreHelper = (score: number): string => {
  if (score < 0) return 'Invalid score';

  if (score >= 0 && score <= 499) {
    return 'Rookie';
  }
  if (score >= 500 && score <= 1499) {
    return 'Pro';
  }
  if (score >= 1500 && score <= 2999) {
    return 'All-Star';
  }
  if (score >= 3000 && score <= 4999) {
    return 'MVP';
  }
  if (score >= 5000) {
    return 'Hall of Famer';
  }

  return '';
};

export const getNewLevelScoreThreshold = (score: number): number | string => {
  if (score < 0) return 'Invalid score';

  if (score >= 0 && score <= 499) {
    // For "Rookie": score range 0-499, maximum is 499
    return 499;
  }
  if (score >= 500 && score <= 1499) {
    // For "Pro": score range 500-1499, maximum is 1499
    return 1499;
  }
  if (score >= 1500 && score <= 2999) {
    // For "All-Star": score range 1500-2999, maximum is 2999
    return 2999;
  }
  if (score >= 3000 && score <= 4999) {
    // For "MVP": score range 3000-4999, maximum is 4999
    return 4999;
  }
  if (score >= 5000) {
    // "Hall of Famer" has no upper limit.
    return 'Maximum level reached';
  }

  return 'Unknown level';
};

export const pointsToNextLevel = (score: number): number | string => {
  if (score < 0) return 'Invalid score';

  // Rookie: 0 - 499; next level (Pro) starts at 500
  if (score < 500) {
    return 500 - score;
  }

  // Pro: 500 - 1499; next level (All-Star) starts at 1500
  if (score < 1500) {
    return 1500 - score;
  }

  // All-Star: 1500 - 2999; next level (MVP) starts at 3000
  if (score < 3000) {
    return 3000 - score;
  }

  // MVP: 3000 - 4999; next level (Hall of Famer) starts at 5000
  if (score < 5000) {
    return 5000 - score;
  }

  // Hall of Famer: 5000+; maximum level reached
  return 'Maximum level reached';
};

export const currentLevelPercentage = (score: number): number => {
  if (score < 0) return 0;

  // Rookie: 0 - 499
  if (score <= 499) {
    // Calculate percentage progress within the Rookie range.
    // Lower bound = 0, Upper bound = 499.
    return (score / 499) * 100;
  }

  // Pro: 500 - 1499
  if (score <= 1499) {
    // Lower bound = 500, Upper bound = 1499.
    return ((score - 500) / (1499 - 500)) * 100;
  }

  // All-Star: 1500 - 2999
  if (score <= 2999) {
    // Lower bound = 1500, Upper bound = 2999.
    return ((score - 1500) / (2999 - 1500)) * 100;
  }

  // MVP: 3000 - 4999
  if (score <= 4999) {
    // Lower bound = 3000, Upper bound = 4999.
    return ((score - 3000) / (4999 - 3000)) * 100;
  }

  // Hall of Famer: 5000+ (no upper bound)
  return 5000;
};
